// extracted by mini-css-extract-plugin
export var fullWidthButton = "_g6-0";